import { render, staticRenderFns } from "./StudentLocus.vue?vue&type=template&id=262210e2&"
import script from "./StudentLocus.vue?vue&type=script&lang=js&"
export * from "./StudentLocus.vue?vue&type=script&lang=js&"
import style0 from "./StudentLocus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports